module.exports = __webpack_public_path__ + "img/nav-thumbnail-ganesha-dx.f823d460.png";